export default __webpack_public_path__ + "static/media/map-marker.656ade68.svg";